import React, { useState, useMemo } from "react";
import "./Booking.css";

const servicesList = [
  { name: "Hair Styling", subs: ["Hair Cut","Hair Color","Hair Treatment","Blow Dry","Keratin Treatment","Layered Cut","Perming","Scalp Massage","Updo Styling","Hair Spa"] },
  { name: "Facial & Spa", subs: ["HD Bridal Makeup","Airbrush Bridal","Traditional Look","Engagement Look","Reception Makeup","Party Makeup","Pre-wedding Makeup","Haldi Look","Sangeet Makeup","Bridesmaid Makeup"] },
  { name: "Makeup", subs: ["HD Bridal Makeup","Airbrush Bridal","Traditional Look","Engagement Look","Reception Makeup","Party Makeup","Pre-wedding Makeup","Haldi Look","Sangeet Makeup","Bridesmaid Makeup"] },
  { name: "Manicure", subs: ["Classic Manicure","French Manicure","Gel Manicure","Spa Manicure","Acrylic Manicure","Gel Polish","Deluxe Manicure","Matte Finish","Nail Art Basic","Nail Art Premium"] },
  { name: "Pedicure", subs: ["Classic Pedicure","French Pedicure","Gel Pedicure","Spa Pedicure","Acrylic Pedicure","Deluxe Pedicure","Matte Finish Pedicure","Nail Art Pedicure","Luxury Spa Pedicure","Herbal Pedicure"] },
  { name: "Massage", subs: ["Swedish Massage","Deep Tissue Massage","Aromatherapy Massage","Hot Stone Massage","Thai Massage","Balinese Massage","Reflexology Massage","Shiatsu Massage","Couple Massage","Head & Shoulder Massage"] },
  { name: "Nail Art", subs: ["Classic Nail Art","French Tips","Gel Nail Art","3D Nail Art","Matte Finish","Glitter Nails","Ombre Nails","Stiletto Nails","Acrylic Nail Art","Luxury Nail Design"] },
  { name: "Threading", subs: ["Eyebrow Threading","Upper Lip Threading","Chin Threading","Full Face Threading","Eyebrow Shaping","Sideburn Threading","Neck Threading","Eyebrow Tint & Thread","Upper Lip & Chin Combo","Full Face Deluxe"] },
  { name: "Waxing", subs: ["Full Leg Wax","Half Leg Wax","Full Arm Wax","Half Arm Wax","Underarm Wax","Back Wax","Chest Wax","Bikini Wax","Full Body Wax","Eyebrow Wax"] },
  { name: "Skin Treatment", subs: ["Acne Treatment","Anti-Aging Treatment","Glow Facial","Hydrating Facial","Vitamin C Facial","Deep Cleansing Facial","Brightening Treatment","Laser Skin Treatment","Pigmentation Treatment","Collagen Facial"] },
];

export default function Booking() {
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    email: "",
    service: servicesList[0].name,
    subService: servicesList[0].subs[0],
    date: "",
    time: "",
    notes: "",
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const currentSubs = useMemo(() => {
    const found = servicesList.find((s) => s.name === form.service);
    return found ? found.subs : [];
  }, [form.service]);

  React.useEffect(() => {
    if (!currentSubs.includes(form.subService)) {
      setForm((f) => ({ ...f, subService: currentSubs[0] || "" }));
    }
  }, [currentSubs]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  }

  function validate() {
    const err = {};
    if (!form.fullName.trim()) err.fullName = "Full name required";
    if (!/^[0-9]{7,15}$/.test(form.phone.replace(/\D/g, "")))
      err.phone = "Enter a valid phone number (7-15 digits)";
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) err.email = "Email looks invalid";
    if (!form.date) err.date = "Please pick a date";
    if (!form.time) err.time = "Please pick a time";
    setErrors(err);
    return Object.keys(err).length === 0;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    setShowModal(true);
  }

  function confirmBooking() {
    setConfirmed(true);
    setTimeout(() => setShowModal(false), 900);
  }

  return (
    <div className="booking-page">
      <div className="booking-center">
        <div className="hero-card">
          <h2>Book Your Appointment</h2>
          <form className="booking-form" onSubmit={handleSubmit} noValidate>
            <div className={`field ${form.fullName ? "has-value" : ""}`}>
              <input name="fullName" value={form.fullName} onChange={handleChange} autoComplete="name"/>
              <label>Full name</label>
              {errors.fullName && <small className="error">{errors.fullName}</small>}
            </div>

            <div className="two-col">
              <div className={`field ${form.phone ? "has-value" : ""}`}>
                <input name="phone" value={form.phone} onChange={handleChange}/>
                <label>Phone</label>
                {errors.phone && <small className="error">{errors.phone}</small>}
              </div>

              <div className={`field ${form.email ? "has-value" : ""}`}>
                <input name="email" value={form.email} onChange={handleChange}/>
                <label>Email (optional)</label>
                {errors.email && <small className="error">{errors.email}</small>}
              </div>
            </div>

            <div className="two-col">
              <div className="field select-field">
                <select name="service" value={form.service} onChange={handleChange}>
                  {servicesList.map((s) => (<option key={s.name} value={s.name}>{s.name}</option>))}
                </select>
              </div>

              <div className="field select-field">
                <select name="subService" value={form.subService} onChange={handleChange}>
                  {currentSubs.map((sub) => (<option key={sub} value={sub}>{sub}</option>))}
                </select>
              </div>
            </div>

            <div className="two-col">
              <div className={`field ${form.date ? "has-value" : ""}`}>
                <input name="date" type="date" value={form.date} onChange={handleChange}/>
                {errors.date && <small className="error">{errors.date}</small>}
              </div>

              <div className={`field ${form.time ? "has-value" : ""}`}>
                <input name="time" type="time" value={form.time} onChange={handleChange}/>
                {errors.time && <small className="error">{errors.time}</small>}
              </div>
            </div>

            <div className={`field ${form.notes ? "has-value" : ""}`}>
              <textarea name="notes" rows="3" value={form.notes} onChange={handleChange} placeholder="Any notes..."/>
            </div>

            <div className="cta-row">
              <button type="submit" className="btn-primary">Book Appointment</button>
              <button type="button" className="btn-ghost" onClick={() => setForm({
                fullName: "", phone: "", email: "", service: servicesList[0].name,
                subService: servicesList[0].subs[0], date: "", time: "", notes: "",
              })}>Reset</button>
            </div>
          </form>
        </div>
      </div>

      {showModal && (
        <div className="modal-backdrop">
          <div className="modal-card">
            {!confirmed ? (
              <>
                <h3>Confirm Appointment</h3>
                <div className="modal-details">
                  <div><b>Name:</b> {form.fullName || "-"}</div>
                  <div><b>Phone:</b> {form.phone}</div>
                  <div><b>Email:</b> {form.email || "-"}</div>
                  <div><b>Service:</b> {form.service} → {form.subService}</div>
                  <div><b>Date & Time:</b> {form.date} {form.time}</div>
                  {form.notes && <div><b>Notes:</b> {form.notes}</div>}
                </div>
                <div className="modal-actions">
                  <button className="btn-primary" onClick={confirmBooking}>Confirm</button>
                  <button className="btn-ghost" onClick={() => setShowModal(false)}>Edit</button>
                </div>
              </>
            ) : (
              <div className="success-state">
                <div className="checkmark">✓</div>
                <h3>Appointment Confirmed</h3>
                <p>Thank you {form.fullName || "Guest"} — your appointment for <b>{form.subService}</b> on <b>{form.date}</b> at <b>{form.time}</b> is confirmed.</p>
                <button className="btn-primary" onClick={() => { setShowModal(false); setConfirmed(false); }}>Close</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
